<script lang="ts">
  import { focus } from "../actions";
  import { kReleaseNotesSystemNoteName } from "../constants";
  import ListBox from "./ListBox.svelte";

  interface Props {
    selectItem: (name: string) => void;
  }
  let { selectItem }: Props = $props();

  // svelte-ignore non_reactive_update
  let initialSelection = 0;

  let listboxComp: ListBox;

  let items = [
    {
      name: "Documentation",
      key: "/help",
    },
    {
      name: "Keyboard shortcuts",
      key: "/help#keyboard-shortcuts",
    },
    {
      name: "Release notes",
      key: kReleaseNotesSystemNoteName,
    },
    {
      name: "GitHub",
      key: "https://github.com/kjk/edna",
    },
    {
      name: "Contact Me",
      key: "https://blog.kowalczyk.info/contactme",
    },
  ];

  function onkeydown(ev: KeyboardEvent) {
    listboxComp.onkeydown(ev, true);
  }
</script>

<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<form
  {onkeydown}
  tabindex="-1"
  use:focus
  class="absolute -left-4 flex flex-col -mt-0.5 z-20 text-sm p-2 bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-500 border rounded-lg focus:outline-hidden"
>
  <ListBox bind:this={listboxComp} {items} onclick={(item) => selectItem(item.key)} {initialSelection} compact={false}>
    {#snippet renderItem(item, idx)}
      <div title={item.key} class="text-left px-1 grow self-end max-w-[32ch] truncate">
        {item.name}
      </div>
    {/snippet}
  </ListBox>
</form>
